export const AIRBRAKE_PROJECT_ID = 685582;
export const AIRBRAKE_PROJECT_KEY = '1e3034042b7fa3bcf9e959b49ec29d6a';

/**
 * Visitors whose errors we never want in Airbrake at all, matched case-insensitively anywhere in the
 * user agent: the notifier is never created for them. Empty on purpose. A crawler's render errors are
 * worth seeing, because search engines index what their renderers see — the Apple Pay crash and the
 * hydration failures both surfaced through Google's crawlers. A crawler that is only noisy about the
 * WAF belongs in WAF_REPORT_IGNORED_USER_AGENTS instead.
 */
export const IGNORED_USER_AGENTS: readonly string[] = [];

/**
 * Crawlers whose wafFetch reports (sdk_missing, token_failed, challenged) are skipped, matched the same
 * way; everything else they hit is still reported. The WAF lets these through without a token, and
 * their renderers routinely never run the WAF SDK, so Googlebot and meta-externalagent reported
 * sdk_missing on every product page they crawled. The entries are the WAF's own declared-crawler
 * list (dmagz-infra `waf-declared-crawler-ua`) plus storebot-google, which that list does not name.
 */
export const WAF_REPORT_IGNORED_USER_AGENTS: readonly string[] = [
  'googlebot',
  'googleother',
  'storebot-google',
  'adsbot-google',
  'mediapartners-google',
  'google-inspectiontool',
  'google-read-aloud',
  'bingbot',
  'adidxbot',
  'bingpreview',
  'applebot',
  'pinterestbot',
  'duckduckbot',
  'duckassistbot',
  'gptbot',
  'chatgpt-user',
  'oai-searchbot',
  'claudebot',
  'claude-user',
  'claude-searchbot',
  'facebookexternalhit',
  'meta-externalads',
  'meta-externalagent',
  'meta-webindexer',
  'criteo',
  'proximic',
  'ias_crawler',
  'amazonbot',
  'perplexitybot',
  'ccbot',
];
